var render = function render(){var _vm=this,_c=_vm._self._c;return _c('core-filter-bar',[_c('core-filter-bar-left',[_c('core-filter-summary',{attrs:{"title":"Tools","icon":"tools","count":_vm.count,"noun":"tool"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }